import { CustomPageType, FeatureFlag, MenuItemNested } from '@core/const';
import { StateUtils } from '@spartacus/core';

export const CORE_FEATURE = 'customCore';
export const FEATURE_FLAGS = '[FEATURE FLAGS]';
export const MENU_NESTED = '[Core] Menu Nested';

export interface ProductListLoadingState {
  loading: boolean;
}

export interface CoreState {
  featureFlags: StateUtils.LoaderState<FeatureFlag[]>;
  customCms: {
    pageIndex: CustomIndexType;
  };
  menusNested: StateUtils.EntityLoaderState<MenuItemNested[]>;
}

export interface StateWithCore {
  [CORE_FEATURE]: CoreState;
}

export type CustomIndexType = {
  [pageType in CustomPageType]: StateUtils.EntityLoaderState<string>;
};
